import PIXI from '../GameEngine/pixi.js';
import Card from '../Sprites/Card.js'
export default class Cards extends PIXI.Container {
    constructor(cards, deck, ...arg) {
        super(...arg);
        this.isDirty = 0;
        this.cardTouched = function () { };
        this.cardUIs = [];
        this.deck = deck;
        //tweenGroup
        this.tweenGroup = new TWEEN.Group();

        //create cards
        for (let i = 0; i < cards.length; i++) {
            let card = cards[i];
            let cardUI = new Card(card);
            cardUI.on('pointerdown', this.onCardTouched.bind(this));
            this.cardUIs.push(cardUI)
            this.addChild(cardUI);
            // //add tween
            cardUI.tween = new TWEEN.Tween(cardUI, this.tweenGroup);
            cardUI.tween.easing(TWEEN.Easing.Exponential.Out);
        }
        this.update();
    }
    getDeck(deck) {
        let path = "assets/Decks/PixaromaDeck_SpriteSheet.json";

        if (deck === "PixaromaDeck")
            path = "assets/Decks/PixaromaDeck_SpriteSheet.json";
        if (deck === "PirateDeck")
            path = "assets/Decks/PirateDeck_SpriteSheet.json";
        if (deck === "LargeNumberDeck")
            path = "assets/Decks/LargeNumberDeck_SpriteSheet.json";
        if (deck === "HalloweenDeck")
            path = "assets/Decks/HalloweenDeck_SpriteSheet.json";
        if (deck === "MedievalDeck")
            path = "assets/Decks/MedievalDeck_SpriteSheet.json";
        if (deck === "ClassicDeck")
            path = "assets/Decks/ClassicDeck_SpriteSheet.json";
        if (deck === "FantasyDeck")
            path = "assets/Decks/FantasyDeck_SpriteSheet.json";
        if (deck === "WildWestDeck")
            path = "assets/Decks/WildWestDeck_SpriteSheet.json";

        return path;
    }
    updateLayout() {
        if (!this.deck) return;

        let isDirty = false;

        let deckPath = this.getDeck(this.deck);


        //get loader
        let loader = PIXI.Loader.shared;
        //can't add while loading, just wait until next updateLayout
        if (!loader.loading) {
            if (loader.resources[deckPath]) {
                let textures = loader.resources[deckPath].textures;
                if (textures) {
                    const keys = Object.keys(textures);
                    for (const key of keys) {
                        //check if in cache and remove
                        PIXI.Texture.removeFromCache(key);

                        let texture = textures[key];
                        PIXI.Texture.addToCache(texture, key);
                    }
                    this.update(true);
                }
            } else {
                //PIXI.utils.TextureCache["Deck"].destroy(true); 
                //PIXI.utils.clearTextureCache();
                // let textures = loader.resources["Deck"].textures;
                // if (textures) {
                //     const keys = Object.keys(textures);
                //     for (const key of keys) {
                //         //check if in cache and remove
                //         PIXI.Texture.removeFromCache(key);
                //     }
                // }
                //const loader1 = new PIXI.Loader();
                //loader.add(deckPath, deckPath);
                // loader.pre((resource, next) => {
                //     //clear old texture caches
                //     console.log("loader.pre",resource);
                //     next();
                // });
                // loader.use((resource, next) => {
                //     //clear old texture caches
                //     console.log("loader.use",resource);
                //     next();
                // });
                // loader.load((loader, resources) => {
                //     //force update textures
                //     this.update(true);
                // });
                loader.add(deckPath, deckPath);
                loader.load((loader, resources) => {
                    //force update textures
                    this.update(true);
                });
            }
        }

        return isDirty;

    }
    update(force) {
        let isDirty = false;
        if (force) isDirty = true;

        //create tweens if pile changed
        if (this.isdirtyCardsPos === true || force) {
            this.updateCardsPos(this.cards, this.layout);
        }

        let anyTweensUpdated = this.tweenGroup.update();
        if (anyTweensUpdated) isDirty = true;

        //if tween has ended, force all cards to position 
        if (!anyTweensUpdated) {
            for (let i = 0; i < this.cardUIs.length; i++) {
                let cardUI = this.cardUIs[i];
                if (cardUI) {
                    //mark dirty if not all in place
                    if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
                        isDirty = true;
                        cardUI.x = cardUI.targetX;
                        cardUI.y = cardUI.targetY;
                    }
                }
            }
        }


        //// no tween - jump to location if pile changed
        // if (this.isdirtyCardsPos === true || force) {
        //     this.updateCardsPos(this.cards, this.layout);
        //     for (let i = 0; i < this.cardUIs.length; i++) {
        //         let cardUI = this.cardUIs[i];
        //         if (cardUI) {
        //             mark dirty if not all in place
        //             if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
        //                 isDirty = true;
        //                 cardUI.x = cardUI.targetX;
        //                 cardUI.y = cardUI.targetY;
        //             }
        //         }
        //     }
        // }


        return isDirty;


    }

    onCardTouched(event) {
        // let cardId = event.currentTarget.id;
        //todo: make this trigger an event without having a refence to context
        // this.cribbage.action("play", cardId, "player1");
        if (this.cardTouched) this.cardTouched(event);

    }
    hasCardMoved() {
        return this.isdirtyCardsPos;
    }
    updateCards(cards, layout) {
        this.isdirtyCardsPos = true;
        this.cards = cards;
        this.layout = layout;
    }

    updateCardsPos(cards, layout) {
        //todo: could pass in state and pile could have different layout per state.

        //clear tweens
        this.tweenGroup.removeAll();

        //done://todo: optimize to only be called once and not for every card moved - could use - addOnce(fn, context, priority)PIXI.ticker.Ticker Ticker.js - Add a handler for the tick event which is only execute once.
        //done://note: or a flag for the game loop to do on dirty

        //note: could loop through cards and if no cardUI found create it
        //note: better to have a single batch update ui as z is need to be know
        //note:  but then again it is known from the model

        //todo: optimize - either move single card or all cards or pile update
        //todo: optimize - card lookup using hash or saving card reference on cardUI.
        //update cardUIs from model
        for (let i = 0; i < this.cardUIs.length; i++) {
            let cardUI = this.cardUIs[i];
            //let cardModel = cardUI.card; //note: might not want to not have reference to model on card
            let cardModel = null;
            for (let j = 0; j < cards.length; j++) {
                let card = cards[j];
                if (cardUI.id === card.id) {
                    cardModel = card;
                    break;
                }
            }
            if (!cardModel)
                continue;
            let pile = cardModel.pile;

            //update from model
            cardUI.pile = cardModel.pile; //update from model
            cardUI.showfront = cardModel.showfront //todo: optimize updating texture only if needed
            cardUI.zOrder = cardModel.pilez;
            cardUI.isSelected = cardModel.isSelected;
            cardUI.owner = cardModel.owner;

        }

        //loop through each pile and update cardUIs
        for (const pile in layout) {
            let pileLayout = layout[pile];
            if (pileLayout) {


                let pileCardUIs = this.getPile(this.cardUIs, pile);
                let pilecount = pileCardUIs.length; //optimize: this should not be called on ever card, but on each pile

                if (pileLayout.ignore) continue;
                

                //merge pile play and played cards
                if (pileLayout.mergePile) {
                    let pileCardUIs2 = this.getPile(this.cardUIs, pileLayout.mergePile);
                    //reasign z order to match new pile count
                    let pileCardUIs2Count = pileCardUIs2.length;
                    for (let i = 0; i < pileCardUIs.length; i++) {
                        let cardUI = pileCardUIs[i];
                        cardUI.zOrder = cardUI.zOrder + pileCardUIs2Count;
                    }
                    pileCardUIs = pileCardUIs.concat(pileCardUIs2);
                    pilecount = pileCardUIs.length;

                }

                if (pilecount === 0) continue;


                //if random order then randomize the order the same each time based on preset random z when game loaded
                if (pileLayout.randomZOrder === true) {
                    pileCardUIs.sort(function (a, b) { return a.randomId - b.randomId; });
                    for (let i = 0; i < pileCardUIs.length; i++) {
                        let cardUI = pileCardUIs[i];
                        cardUI.zOrder = pileCardUIs.indexOf(cardUI);
                    }
                }


                //helper for staggard piles
                let offsetXCurrent = null;
                let lastCardPile = null;

                //order by zOrder
                pileCardUIs.sort(function (a, b) { return a.zOrder - b.zOrder; });
                //loop through each card in pile and update
                for (let i = 0; i < pileCardUIs.length; i++) {
                    let cardUI = pileCardUIs[i];

                    if (pileLayout.showfront !== undefined) {
                        cardUI.showfront = pileLayout.showfront;
                    }
                    if (pileLayout.grayedOut) {
                        cardUI.grayedOut = true;
                    } else {
                        cardUI.grayedOut = false;
                    }
                    cardUI.updateTexture();

                    let pileZ = cardUI.zOrder;


                    if (pileLayout.zOrder) {
                        let offsetZ = pileLayout.offsetZ || 0;
                        cardUI.zOrder = pileZ + offsetZ;
                    }

                    if (pileLayout.pileStyle === "center") {
                        let offsetX = pileLayout.offsetX;
                        let offsetY = pileLayout.offsetY;
                        let count = pilecount - 1;
                        let maxWidth = pileLayout.maxWidth;
                        if (maxWidth && offsetX * pilecount > maxWidth) {
                            offsetX = maxWidth / pilecount;
                        }
                        cardUI.targetX = pileLayout.x + (pileZ * offsetX) - (count * offsetX / 2);
                        cardUI.targetY = pileLayout.y + (pileZ * offsetY) - (count * offsetY / 2);
                        if (cardUI.isSelected) cardUI.targetY += pileLayout.selectedOffsetY || 0;
                        pileLayout.offsetR = pileLayout.offsetR || 0;
                        cardUI.rotation = (pileLayout.r || 0) + (pileZ * pileLayout.offsetR) - (count * pileLayout.offsetR / 2);
                    }
                    if (pileLayout.pileStyle === "basic") {
                        cardUI.targetX = pileLayout.x + (pileZ * (pileLayout.offsetX));
                        cardUI.targetY = pileLayout.y + (pileZ * (pileLayout.offsetY));
                        if (cardUI.isSelected) cardUI.targetY += pileLayout.selectedOffsetY || 0;
                        cardUI.rotation = pileLayout.r || 0;
                    }
                    if (pileLayout.pileStyle === "staggard") {
                        let offsetX = pileLayout.offsetX || 0;

                        //offset for merged piles
                        if (cardUI.pile === pileLayout.mergePile && pileLayout.offsetXMergedPile) {
                            offsetX = pileLayout.offsetXMergedPile;
                        }
                        //gap between piles
                        if (lastCardPile && cardUI.pile !== lastCardPile && pileLayout.offsetXGap) {
                            offsetX = pileLayout.offsetXGap;
                        }
                        //if first card in pile, then no offset
                        if (offsetXCurrent === null) {
                            offsetX = 0;
                            offsetXCurrent = pileLayout.x;
                        } else {
                            offsetXCurrent += offsetX;
                        }
                        lastCardPile = cardUI.pile; //set last pile for next card

                        cardUI.targetX = offsetXCurrent;
                        cardUI.targetY = pileLayout.y + (pileZ * (pileLayout.offsetY));
                        if (cardUI.isSelected) cardUI.targetY += pileLayout.selectedOffsetY || 0;
                        cardUI.rotation = pileLayout.r || 0;
                        //additive offset
                        if (pileLayout.staggerY) {
                            if (pileLayout.staggerPlayer === cardUI.owner) {
                                cardUI.targetY += pileLayout.staggerY;
                            }
                        }
                    }

                    if (pileLayout.randomYOffset) {
                        cardUI.targetY = pileLayout.y + (cardUI.randomId / 100000);
                    }

                    if (pileLayout.width)
                        cardUI.width = pileLayout.width;
                    if (pileLayout.height)
                        cardUI.height = pileLayout.height;
                    if (pileLayout.scale)
                        cardUI.scale.x = cardUI.scale.y = pileLayout.scale || 1;
                    //---------note to JD there is where I left off when I left on 5/2/2024----------------
                }
            }
        }

        //loop each card and update tween in case not in a pile but has a target
        for (let i = 0; i < this.cardUIs.length; i++) {
            let cardUI = this.cardUIs[i];

            //add tweening if needed
            if (cardUI.x != cardUI.targetX || cardUI.y != cardUI.targetY) {
                // cardUI.x = cardUI.targetX ;
                // cardUI.y = cardUI.targetY;
                cardUI.tween.to({ x: cardUI.targetX, y: cardUI.targetY }, 300);
                //cardUI.tween.to({ x: cardUI.targetX, y: cardUI.targetY }, 600);
                cardUI.tween.start();
            }
        }


        //http://pixijs.io/examples/#/layers/zorder.js



        //todo: optimize to only be called once - could use - addOnce(fn, context, priority)PIXI.ticker.Ticker Ticker.js - Add a handler for the tick event which is only execute once.
        //note: or a flag for the game loop to do on dirty
        //update z order for sprites
        this.children.sort(function (a, b) {
            return (a.zOrder || 0) - (b.zOrder || 0);
        });

        this.isdirtyCardsPos = false;
        // this.isDirty = true;

        //this.validateCardLocationBug();
    }
    getPile(cards, pileName) {
        var pileCards = new Array();
        for (var i = 0; i < cards.length; i++) {
            let card = cards[i];
            if (card.pile === pileName) {
                pileCards.push(card);
            }
        }
        //pileCards = this.sortByKey(pileCards, "pilez");
        return pileCards;
    }
    sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
}
